export enum EPlanPeriod {
    MONTHLY = 'monthly',
    ANNUAL = 'annual'
}